export default __webpack_public_path__ + "static/media/city.6f6e699d.png";